import { render, staticRenderFns } from "./ReceiversList.vue?vue&type=template&id=5d85beac&scoped=true"
import script from "./ReceiversList.vue?vue&type=script&lang=js"
export * from "./ReceiversList.vue?vue&type=script&lang=js"
import style0 from "./ReceiversList.vue?vue&type=style&index=0&id=5d85beac&prod&lang=scss&scoped=true"
import style1 from "./ReceiversList.vue?vue&type=style&index=1&id=5d85beac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d85beac",
  null
  
)

export default component.exports